<template>
  <div class="criteria-field-cell">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.criteria-field-cell {
  display: block;
  min-width: 0;
  width: 100%;

  :deep(.box.selector-label) {
    box-sizing: border-box;
    width: 100%;
    max-width: none;
    background: var(--inverted);
    border: 1px solid var(--secondary-12);
    border-radius: 8px;
  }

  :deep(.box.selector-label--disabled) {
    background: rgba(34, 34, 34, 0.04);
  }

  :deep(.el-input.is-disabled .el-input__wrapper) {
    background: rgba(34, 34, 34, 0.04);
    box-shadow: 0 0 0 1px var(--secondary-12) inset;
  }

  :deep(.el-input.is-disabled .el-input__inner) {
    color: var(--primary);
    opacity: 0.48;
    -webkit-text-fill-color: currentcolor;
  }

  :deep(.el-input.is-disabled .el-input__prefix),
  :deep(.el-input.is-disabled .el-input__suffix) {
    opacity: 0.48;
  }

  :deep(.box.selector-label .flex) {
    justify-content: space-between;
  }

  :deep(.el-dropdown) {
    display: flex;
    width: 100%;
  }

  :deep(.el-input) {
    width: 100%;
  }
}
</style>
